import React from 'react'
import Sidenav from '../../components/Sidenav/Sidenav';
import { Outlet } from 'react-router-dom';

const Layout = () => {
  return (
    <>
    <div className='flex flex-col flex-grow xs:flex-row min-h-[50vh]'>
      <Sidenav />
      <Outlet />
    </div>
    </>
  )
}

export default Layout;